import React from 'react';
import { useTranslation } from 'react-i18next';

export default function OnboardingOverlay({ onDismiss }) {
    const { t } = useTranslation();

    const tips = [
        {
            icon: '📱',
            title: t('Share the QR code'),
            desc: t('Guests scan the code on screen and the camera opens instantly. No app needed.'),
        },
        {
            icon: '🖼️',
            title: t('Photos appear live'),
            desc: t('Every photo lands on the wall the moment it is taken.'),
        },
        {
            icon: '⚙️',
            title: t('Customise anytime'),
            desc: t('Move your mouse to reveal the controls. Switch between Cinematic and Board mode, or open Settings.'),
        },
    ];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden">
                {/* Header */}
                <div className="bg-purple-600 px-6 py-5 text-white relative">
                    <button
                        onClick={onDismiss}
                        className="absolute top-4 right-4 text-white/50 hover:text-white transition"
                    >✕</button>
                    <div className="flex items-center gap-2 mb-1">
                        <span className="w-2 h-2 rounded-full bg-white/60 animate-pulse" />
                        <span className="text-xs font-semibold uppercase tracking-widest text-white/70">{t('Live Photo Wall')}</span>
                    </div>
                    <h2 className="text-xl font-bold">{t('Welcome to the wall!')}</h2>
                    <p className="text-sm text-white/80 mt-1">{t('Everything you need to know.')}</p>
                </div>

                {/* Tips */}
                <div className="px-6 py-5 space-y-4">
                    {tips.map(({ icon, title, desc }) => (
                        <div key={title} className="flex gap-3">
                            <span className="text-2xl shrink-0 leading-none">{icon}</span>
                            <div>
                                <div className="font-semibold text-sm text-gray-900">{title}</div>
                                <div className="text-xs text-gray-500 mt-0.5 leading-snug">{desc}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Action */}
                <div className="px-6 pb-5">
                    <button
                        onClick={onDismiss}
                        className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2.5 rounded-xl transition text-sm"
                    >
                        {t('Got it, start the show!')}
                    </button>
                </div>
            </div>
        </div>
    );
}
